/** CRA inlines REACT_APP_*; VITE_* listed for parity with other funnels. */
function readEnv(...keys) {
  for (const key of keys) {
    const value = process.env[key];
    if (value) return value;
  }
  return "";
}

export const STRIPE_PUBLISHABLE_KEY = readEnv(
  "REACT_APP_STRIPE_PUBLISHABLE_KEY",
  "VITE_STRIPE_PUBLISHABLE_KEY"
);

export function isStripeLivePublishableKey(key = STRIPE_PUBLISHABLE_KEY) {
  return typeof key === "string" && key.startsWith("pk_live_");
}

export function isStripeTestPublishableKey(key = STRIPE_PUBLISHABLE_KEY) {
  return typeof key === "string" && key.startsWith("pk_test_");
}

export function getStripeMode() {
  if (isStripeLivePublishableKey()) return "live";
  if (isStripeTestPublishableKey()) return "test";
  return "unknown";
}

/** Optional override if backend exposes a dedicated live endpoint */
export function getPaymentIntentUrlOverride() {
  return readEnv("REACT_APP_CREATE_PAYMENT_INTENT_URL");
}
